import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';

import { GlobalState } from '../../../../store/types';
import { setBadgeCount } from '../../../../store/actions';

import socket from '../../../../socket/socket';
import NewLauncher from '../NewLauncher';
import './style.scss';


const openLauncher = require('../../../../../assets/launcher_button.svg') as string;
const arrow = require('../../../../../assets/arrow-top.svg') as string;

type Props = {
  toggle: () => void;
  chatId: string;
  openLabel: string;
  closeLabel: string;
  closeImg: string;
  openImg: string;
  showBadge?: boolean;
  showChat: boolean;
  title?: string;
  titleAvatar?: string;
  subtitle?: string;
}

function Launcher({ toggle, openImg, closeLabel, title, titleAvatar, subtitle }: Props) {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const vkLink = process.env.VK_LINK || 'https://vk.com';
  const { showChat } = useSelector((state: GlobalState) => ({
    showChat: state.behavior.showChat,
    badgeCount: state.messages.badgeCount,
    client_id: state.rooms.client_id,
    room_id: state.rooms.room_id,
  }));

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenChat = () => {
    // Закрываем модальное окно сразу
    setShowModal(false);
    // Открываем чат - toggle() вызывает handleToggleConversation() который вызывает toggleConversation()
    // toggleConversation() вызывает dispatch(toggleChat()) который меняет showChat в state
    toggle();
    // Сбрасываем счетчик бейджей
    dispatch(setBadgeCount(0));
  }

  const handleVkClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(vkLink, '_blank', 'noopener,noreferrer');
  };

  if (showChat) {
    return null
  }

  return (
    <>
      {!showModal && (
        <div className="rcw-new-launcher-wrapper">
          <a
            href={vkLink}
            target="_blank"
            rel="noopener noreferrer"
            className="rcw-new-launcher-btn-vk"
            id="rcw-vk-button-launcher"
            onClick={handleVkClick}
          >
            MAX
          </a>
          <div className='rcw-launcher' onClick={handleOpenModal}>
            <div className='rcw-launcher-preview'>
              <img src={openImg || openLauncher} className="launcher-preview-icon" alt={closeLabel} />
              <h4 className='launcher-preview-title'>{title}</h4>
            </div>
            <img src={arrow} className='rcw-launcher-switcher' alt={closeLabel} />
          </div>
        </div>
      )}
      {showModal && (
        <NewLauncher
          onOpenChat={handleOpenChat}
          onClose={handleCloseModal}
          title={title}
          titleAvatar={titleAvatar}
          subtitle={subtitle}
        />
      )}
    </>
  );
}

export default Launcher;
